<p class="blur-text">Hide portfolio values:</p>
<mat-icon class="info-icon" [matTooltip]="tooltipText">info_fill</mat-icon>
<mat-slide-toggle (change)="change($event)"></mat-slide-toggle>
